// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1LtKu","upload":"Small_upload__3_9jy","imageWrap":"Small_imageWrap__3bpyy","removeBtn":"Small_removeBtn__1iR-f"};